module.exports = __webpack_public_path__ + "static/media/homePage.0f2fc177.jpg";